import styled from "styled-components"
import {DESKTOP, PHONE_LANDSCAPE, TABLET} from "@irati/ui/src/global/media"
import ImageOne from "@irati/ui/images/wallet-onboarding-icon-one.svg"
import ImageTwo from "@irati/ui/images/wallet-onboarding-icon-two.svg"
import ImageThree from "@irati/ui/images/wallet-onboarding-icon-three.svg"
import {Step} from "./OnboardingCard"

export const RewardInformationSection = styled.div`
  ${({theme}) => `background-color: ${theme.colors.greys.white};`}
`

export const sliderSettings = {
  responsive: [
    {breakpoint: PHONE_LANDSCAPE - 1, settings: {slidesToShow: 1, slidesToScroll: 1, nextArrow: null, prevArrow: null}},
    {breakpoint: TABLET - 1, settings: {slidesToShow: 1.2, slidesToScroll: 1}},
    {breakpoint: DESKTOP - 1, settings: {slidesToShow: 2, slidesToScroll: 2}}
  ]
}

export const adminSteps: Record<string, Step> = {
  stepOne: {
    title: "wallet.reward.onboarding.admin.title.one",
    content: "wallet.reward.onboarding.admin.content.one",
    currentStep: 0,
    image: ImageOne
  },
  stepTwo: {
    title: "wallet.reward.onboarding.admin.title.two",
    content: "wallet.reward.onboarding.admin.content.two",
    currentStep: 1,
    image: ImageTwo
  },
  stepThree: {
    title: "wallet.reward.onboarding.admin.title.three",
    content: "wallet.reward.onboarding.admin.content.three",
    currentStep: 2,
    image: ImageThree
  }
}
export const maangerSteps: Record<string, Step> = {
  stepOne: {
    title: "wallet.reward.onboarding.manager.title.one",
    content: "wallet.reward.onboarding.manager.content.one",
    currentStep: 0,
    image: ImageOne
  },
  stepTwo: {
    title: "wallet.reward.onboarding.manager.title.two",
    content: "wallet.reward.onboarding.manager.content.two",
    currentStep: 1,
    image: ImageTwo
  },
  stepThree: {
    title: "wallet.reward.onboarding.manager.title.three",
    content: "wallet.reward.onboarding.manager.content.three",
    currentStep: 2,
    image: ImageThree
  }
}
